import { useEffect, useState } from "react";
import { JobsSummaryDocument } from "../types";

interface JobsApiResponse {
    success: boolean,
    data: JobsSummaryDocument | null
}

export default function useJobsAPI() {

    const [loading, setLoading] = useState(false)
    const [summary, setSummary] = useState<JobsSummaryDocument | null>(null)

    async function fetchSummary(jobScannerKey: string, region?: string) {
        // await _delay(2000)
        setLoading(true)

        const api_url = process.env.REACT_APP_API_SERVER_URL
        const api_version = process.env.REACT_APP_API_VERSION
        const res = await fetch(`${api_url}/api/${api_version}/jobs?keys=${jobScannerKey}${Boolean(region) ? `&region=${region}` : ''}`,
            {
                credentials: 'include',
                cache: 'no-store',
            }
        )

        const apiResponse: JobsApiResponse = await res.json()
        const batchSummary = apiResponse.data

        setLoading(false)
        setSummary(batchSummary)

    }

    return { loading, summary, fetchSummary }
}